import { css } from '@emotion/react';

import { breakpoints, colors } from '@/styles';
import { p2r, SecondaryProps } from '@/styles/fonts';

const styles = css`
  position: relative;
  width: 100%;

  @media (max-width: ${breakpoints.tablet + 5}px) {
    margin-top: 0;
  }

  @media (max-width: ${breakpoints.hugeMobile}px) {
    width: 90%;
    margin: 0 5% 0 5%;
  }

  .cardTitle {
    margin: 0 0 ${p2r(10)} 0;
    ${SecondaryProps}
    font-size: ${p2r(26)};
    font-style: normal;
    font-weight: 500;
    line-height: ${p2r(24)};
    color: ${colors.white};
    letter-spacing: -1.3px;

    @media (max-width: ${breakpoints.hugeMobile}px) {
      font-size: ${p2r(22)};
    }
  }

  .cardInfo {
    display: flex;
    gap: 40px;
    padding-bottom: ${p2r(20)};

    @media (max-width: ${breakpoints.hugeMobile}px) {
      flex-direction: column;
    }
  }

  .cardInfo-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: ${breakpoints.hugeMobile}px) {
      gap: 20px;
    }
  }

  .cardText {
    width: 100%;
    max-width: 285px;
    margin: 0;
    ${SecondaryProps}
    font-size: ${p2r(18)};
    font-style: normal;
    font-weight: normal;
    line-height: ${p2r(18.7)};
    color: ${colors.white};
    letter-spacing: normal;

    @media (max-width: ${breakpoints.tablet + 90}px) {
      font-size: ${p2r(18)};
    }

    @media (max-width: ${breakpoints.hugeMobile}px) {
      font-size: ${p2r(16)};
      line-height: ${p2r(22)};
    }
  }

  .cardImg-container {
    width: 100%;
    max-width: 256px;
    height: 100%;
    max-height: ${p2r(206)};
    overflow: hidden;
    cursor: pointer;

    @media (max-width: ${breakpoints.hugeMobile}px) {
      max-width: 345px;
      max-height: ${p2r(173)};
    }
  }

  .cardImg {
    transition: all 0.5s ease;
    transform: scale(1);

    &:hover {
      transition: all 0.5s ease;
      transform: scale(1.2);
    }

    @media (max-width: ${breakpoints.hugeMobile}px) {
      display: none;
    }
  }

  .cardImgMobile {
    display: none;
    transition: all 0.5s ease;
    transform: scale(1);

    &:hover {
      transition: all 0.5s ease;
      transform: scale(1.2);
    }

    @media (max-width: ${breakpoints.hugeMobile}px) {
      display: block;
      min-width: 345px;
    }
  }

  .btn-container {
    max-width: 147px;
  }
`;

export default styles;
